import React from "react";
import ecopet from "../../img/ecopet.jpg";
import quiz from "../../img/quiz.jpg";
import moneymanagement from "../../img/money-management.png";
import webtruyen from "../../img/webtruyen.png";
import hoovada from "../../img/hoovada.png";
const Works = () => {
  return (
    <div className="container">
      <h2> Works</h2>
      <div className="row">
        <div className="col-md-6 col-xl-4 ">
          <div
            className="card"
            data-aos="zoom-in"
            data-aos-easing="ease-in-out"
            data-aos-duration="1000"
          >
            <a href="https://staging.hoovada.com/" target="_blank">
              <img src={hoovada} alt="money_management" loading="lazy" />
            </a>
          </div>
        </div>
        <div className="col-md-6 col-xl-4 ">
          <div
            className="card"
            data-aos="zoom-in"
            data-aos-easing="ease-in-out"
            data-aos-duration="1000"
          >
            <a href="https://webtruyen-hosting.vercel.app/" target="_blank">
              <img src={webtruyen} alt="money_management" loading="lazy" />
            </a>
          </div>
        </div>
        <div className="col-md-6 col-xl-4 ">
          <div
            className="card"
            data-aos="zoom-in"
            data-aos-easing="ease-in-out"
            data-aos-duration="1000"
          >
            <a href="https://money-management-ntq.web.app/" target="_blank">
              <img src={moneymanagement} alt="money_management" loading="lazy" />
            </a>
          </div>
        </div>
        <div className="col-md-6 col-xl-4 ">
          <div
            className="card"
            data-aos="zoom-in"
            data-aos-easing="ease-in-out"
            data-aos-duration="1000"
            data-aos-delay="300"
          >
            <a
              href="https://news.sun-asterisk.com/vi/p/vuot-qua-nhieu-doi-thu-tren-the-gioi-sun-tiep-tuc-chien-thang-tai-torus-hackathon-nhan-giai-thuong-4000-usd-RO6dG5dVNyx"
              target="_blank"
            >
              <img src={ecopet} alt="ecopet" loading="lazy" />
            </a>
          </div>
        </div>
        <div className="col-md-6 col-xl-4">
          <div
            className="card"
            data-aos="zoom-in"
            data-aos-easing="ease-in-out"
            data-aos-duration="1000"
            data-aos-delay="500"
          >
            <a href="https://quiz-291707.web.app/home" target="_blank">
              <img src={quiz} alt="ecopet" loading="lazy" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Works;
